
export enum RuleInheritance {
  User = 1,
  Resource = 2
}
